<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- <ion-title>Notification</ion-title> -->
  </ion-toolbar>

  <div
    style="overflow:auto; max-height: var(--app-height);"
    class="infinite-list-wrapper main_wrapper ion-padding"
  >
    <div class="container">
      <PageTitle title="Notification" subtitle="" showIcon/>
      <div
        v-infinite-scroll="loadNotifications"
        :infinite-scroll-disabled="scrollDisabled"
        class="notifications_messages_wrapper"
      >
      <div v-if="messages.length > 0">
        <div
          class="image_text_comp message bg-white"
          :class="message.status ? '' : 'unread'"
          v-for="message in messages"
          :key="message.id"
          @click="markAsRead(message)"
        >
          <div class="image_wrapper">
            <span class="locumate_icons" :class="getIconBasedOnType(message)"></span>
          </div>
          <div class="text_wrapper">
            <div class="d-flex justify-content-between">
              <div class="main_text">{{ message.subject }}</div>
              <div class="message_date">
                {{
                  message.createdAt
                    ? $moment(message.createdAt)
                        .tz(userTimezone)
                        .fromNow()
                    : $moment(message.created_at)
                        .tz(userTimezone)
                        .fromNow()
                }}
              </div>
            </div>
            <div class="additional_text">
              <div v-html="message.content"></div>
              <div v-if="message.type === 119">
                <div class="job_post_details d-flex flex-wrap justify-content-between" v-if="message.params.jobPostDetails">
                  <div>
                    <h6 class="job-title">{{ message.params.jobPostDetails.jobTitle }}</h6>
                    <p>{{ message.params.jobPostDetails.pharmacyName }}</p>
                  </div>
                  <div class="d-flex gap-1 align-items-center mt-2">
                    <el-tag class="inverted">{{ message.params.jobPostDetails.jobType }}</el-tag>
                    <p>{{ message.params.jobPostDetails.jobLocation }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="no-notification">
          There are no new notifications
        </div>
      
      </div>
      
      </div>
      <p v-if="loading">Loading...</p>
    </div>
  </div>
  <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
</template>

<script>
import {
  ref,
  onMounted,
  computed,
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import PageTitle from "@/components/PageTitle/PageTitle.vue";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
} from "@ionic/vue";

import { useStore } from "vuex";
import {
  useRouter,
} from "vue-router";
import SvgIcon from '@/components/Svg/SvgIcon.vue';
export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    PageTitle,
    SvgIcon
  },
  directives: {},
  setup() {
    const $store = useStore();
    const $router = useRouter();
    let messages = computed(() => {
      return $store.getters.GET_NOTIFICATIONS_MESSAGES;
    });

    const userData = $store.getters.GET_USER_DATA;

    const userTimezone = userData.timezone
      ? userData.timezone
      : "Australia/Melbourne";

    const meta = computed(() => {
      return $store.getters.GET_NOTIFICATIONS_MESSAGES_META;
    });

    const loading = ref(false);
    const scrollDisabled = ref(false);
    const notificationRequest = {
      perPage: 20,
    };

    const loadNotifications = () => {
      if (meta.value.lastPage == 1) {
        scrollDisabled.value = true;
      }
      if (!scrollDisabled.value) {
        loading.value = true;
        scrollDisabled.value = true;
        (async () => {
          try {
            let request = notificationRequest;
            if (meta.value && meta.value.currentPage) {
              request.page = meta.value.currentPage + 1;
            }

            request.hideLoading = true;

            request.action = 'loadMore'; // fixed issue with updating notifications list

            await $store.dispatch("GET_NOTIFICATIONS_MESSAGES", request);

            if (meta.value.currentPage >= meta.value.lastPage) {
              scrollDisabled.value = true;
              loading.value = false;
            } else {
              loading.value = false;
              scrollDisabled.value = false;
            }
          } catch (error) {
            console.log(error);
          }
        })();
      }
    };

    const markAsRead = (message) => {

      console.log('messagesssss', message);

      (async () => {
      try {
        await $store.dispatch(
        "MARK_NOTIFICATION_MESSAGE_AS_READ",
        message.id
        );
      } catch (error) {
        console.log(error);
      }
      })();

      const link = getLinkForMessage(message);

      if (link && link.link) {
      $router.push(link.link);
      }
    };

    
    const getIconBasedOnType = (message) => {
        const link = getLinkForMessage(message);
        console.log("link icon: ", link)
        return link.icon;
    }

    const getLinkForMessage = (message) => {
      let link = null;
      let icon = null;

      console.log('message', message);

      switch (message.type) {
      case 0:
        link = {
        name: "chat_message",
        params: {
          chatId: message.params.id,
        },
        };
        break;

      case 13:
      case 14:
        link = {
        name: "shift_confirm",
        params: {
          shiftId: message.params.id,
        },
        };
        icon = "locumate_icon-calendar-tick";
        break;
      case 18:
      case 17:
        link = {
          name: "job",
          params: {
            jobId: message.params.id,
          },
          };
        icon = "locumate_icon-clock2";
        break;
      case 7:
      case 11:
      case 20:
      case 21:
      case 24:
      case 16:
      case 141:
      case 142:
      case 12:
        link = {
        name: "job",
        params: {
          jobId: message.params.id,
        },
        };
        break;

      case 5:
      case 10:
      case 19:
        link = {
        name: "search",
        };
        break;

      case 25:
        link = {
        name: "chat_list",
        };
        break;
      case 40:
      case 164:
      case 42:
        link = {
        name: "job_book_days",
        params: {
          jobId: message.params.id,
        },
        };
        break;

      case 83:
        link = {
        name: "shift_application_details",
        params: {
          shiftApplicationId: message.params.id,
        },
        };
        break;

      case 84:
      case 87:
        link = {
        name: "job",
        params: {
          jobId: message.params.id || message.params.jobId,
        },
        };
        break;

      case 89:
        link = {
        name: "job_book_days",
        params: {
          jobId: message.params.id,
        },
        };
        break;

      case 90:
        link = {
        name: "job",
        params: {
          jobId: message.params.id,
        },
        };
        break;

      case 93:
        link = {
        name: "job",
        params: {
          jobId: message.params.id,
        },
        };
        break;

      case 115:
        link = {
        name: "job",
        params: {
          jobId: message.params.jobId,
        },
        };
        break;

      case 114:
        link = {
        name: "job",
        params: {
          jobId: message.params.jobId,
        },
        };
        break;

      case 116:
        link = {
        name: "job",
        params: {
          jobId: message.params.jobId,
        },
        };
        break;

      case 119:
        link = {
        name: "job_seeker_application_withdraw",
        params: {
          jobId: message.params.jobPostId,
        },
        };
        icon = "locumate_icon-notification_bell";
        break;

      case 120:
        link = {
        name: "job_poster_applicants_list",
        params: {
          jobId: message.params.jobPostId,
        },
        };
        break;

      case 140:
        link = {
        name: "edit_job_list",
        params: {
          jobId: message.params.jobPostId,
        },
        };
        break;

      default:
        link = null;
        icon = "locumate_icon-notification_bell";
      }

      return {
        link : link,
        icon : icon ? icon : "locumate_icon-notification_bell"
      }
    };

    const goBack = () => {
      $router.push({
        name: "home",
      });
    };

    onMounted(() => {});

    return {
      goBack,
      messages,
      markAsRead,
      meta,
      scrollDisabled,
      loading,
      loadNotifications,
      userTimezone,
      getIconBasedOnType
    };
  },
};
</script>
